import { queryOptions } from '@tanstack/react-query';
import { loyaltyAPIClient } from '../loyaltyAPIClient';
import { LOYALTY_QUERY_KEYS } from './keys';
import type { GetCustomerBalanceRequest, GetTransactionHistoryRequest, GetLoyaltyPolicyRequest } from './types';

export const LOYALTY_QUERIES = {
  getCustomerBalance: ({ customerId, currency }: GetCustomerBalanceRequest) => {
    return queryOptions({
      queryKey: LOYALTY_QUERY_KEYS.getCustomerBalance({ customerId, currency }),
      queryFn: () => {
        return loyaltyAPIClient.getCustomerBalance({ customerId, currency });
      },
    });
  },

  getTransactionHistory: ({ customerId, limit, lastEvaluatedKey, currency }: GetTransactionHistoryRequest) => {
    return queryOptions({
      queryKey: LOYALTY_QUERY_KEYS.getTransactionHistory({ customerId, limit, lastEvaluatedKey, currency }),
      queryFn: () => {
        return loyaltyAPIClient.getTransactionHistory({ customerId, limit, lastEvaluatedKey, currency });
      },
    });
  },

  getLoyaltyPolicy: ({ currency }: GetLoyaltyPolicyRequest) => {
    return queryOptions({
      queryKey: LOYALTY_QUERY_KEYS.getLoyaltyPolicy({ currency }),
      queryFn: () => {
        return loyaltyAPIClient.getLoyaltyPolicy({ currency });
      },
    });
  },
};
